module.exports = __webpack_public_path__ + "img/exito.31a97967.svg";